<template>
	<div>
		<div class="pd30">
			<div>
				<a-button type="primary" icon="plus" @click="bindProjectAct()">绑定项目</a-button>
			</div>
			
			<div class="mt30">
				<div class="wxb-table-gray">
					<a-table rowKey="bind_id" :columns="columns" :pagination="pagination" @change="handleTableChange" :data-source="datas" :loading="loading">
						<div class="flex alcenter center" slot="project" slot-scope="project,record">
							<img :src="project.cover_img"  class="projetc-cover-img" />
							<div class="ml10" style="text-align: left;">
								<div>{{project.abbreviation}}</div>
							</div>
						</div>
							
						<div class="flex alcenter center" slot="market_price" slot-scope="record">
							¥{{record.project.market_price}}
						</div>
					
						<template slot="action" slot-scope="record,index">
							<div class="flex center">
								<a-dropdown placement="bottomRight">
									<span class="more-act">
										<i class="iconfont iconmore_gray"></i>
									</span>
									<a-menu slot="overlay">
									
										<a-menu-item>
											<a class="menu-act" href="javascript:;" @click="delAct(record)">
												<i class="iconfont ft14 icondelete"></i>
												<span class="ml10">解绑</span>
											</a>
										</a-menu-item>
									</a-menu>
								</a-dropdown>
							</div>
						</template>
					</a-table>
				</div>
			</div>
		
			<div v-if="bindProjectVisible">
				<bind-project :visible="bindProjectVisible" :technician_id="technician_id" @cancel="cancelBindProject" @ok="okBindProject"></bind-project>
			</div>
		</div>
	</div>
</template>

<script>
	import {listMixin} from '../../../../common/mixin/list.js';
	import bindProject from './project/modal/bindProject.vue';
	export default{
		props:{
			technician_id:{
				type:Number,
				default:0,
			}
		},
		mixins:[listMixin],
		components:{
			bindProject,
		},
		data(){
			return{
				loading:false,
				bindProjectVisible:false,
				columns: [
					{title: '项目编号',dataIndex: 'project_id',align: 'center'},
					{title: '服务项目',dataIndex: 'project',align: 'center',width:300,scopedSlots: {customRender: 'project'}},
					{title: '门店原价',key: 'market_price',align: 'center',scopedSlots: {customRender: 'market_price'}},
					{title: '已约人次',dataIndex: 'engaged_num',align: 'center',ellipsis: true},
					{title: '创建时间',dataIndex: 'add_time_format',align: 'center',ellipsis: true},
					{title: '操作',key: 'action',align: 'center',scopedSlots: {customRender: 'action'}}
				],
				datas:[],
			}
		},
		methods:{
			
			getLists(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/getTechnicianBindProjectList',{
					limit:this.pagination.pageSize,
					page:this.pagination.current,
					technician_id:this.technician_id
				}).then(res=>{
					this.pagination.total=res.total;
					this.datas=res.list;
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
				})
			},
			
			delAct(record){
				this.$confirm({
					title:'确认解绑这个项目吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('admin/delTechnicianProject',{
								bind_id:record.bind_id,
							}).then(res=>{
								this.$message.success('解绑成功');
								this.getLists();
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},
			
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current;
				this.getLists();
			},
			
			//绑定项目
			bindProjectAct(){
				this.bindProjectVisible=true;
			},
			cancelBindProject(){
				this.bindProjectVisible=false;
			},
			okBindProject(){
				this.bindProjectVisible=false;
				this.getLists();
			}
		}
	}
</script>

<style>
	.projetc-cover-img{
		width: 80px;
		height: 60px;
	}
</style>
